import React from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import { contact } from '../Data/Data';
import { useContactForm } from './useContactForm';
import './Contact.css';

// Cloudflare's always-pass test key keeps local dev working without a real widget.
const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '1x00000000000000000000AA';

const Contact = () => {
    const { form, status, errorMessage, token, setToken, challengeFailed, update, handleSubmit, turnstileRef } =
        useContactForm();

    const field = (name, label, props = {}) => (
        <div className={`field field-${name}`}>
            <label htmlFor={`contact-${name}`}>{label}</label>
            {props.as === 'textarea' ? (
                <textarea id={`contact-${name}`} name={name} rows={5} value={form[name]} onChange={update} required />
            ) : (
                <input id={`contact-${name}`} name={name} value={form[name]} onChange={update} required {...props} />
            )}
        </div>
    );

    return (
        <section className="section contact" id="contact">
            <div className="container contact-grid">
                <div className="contact-intro">
                    <h2>{contact.title}</h2>
                    <p className="lead">{contact.detail}</p>
                    <dl className="contact-detail">
                        {contact.phones.map((p) => (
                            <div key={p.number}>
                                <dt>{p.label}</dt>
                                <dd><a href={`tel:${p.number.replace(/\D/g, '')}`}>{p.number}</a></dd>
                            </div>
                        ))}
                        <div>
                            <dt>Email</dt>
                            <dd><a href={`mailto:${contact.email}`}>{contact.email}</a></dd>
                        </div>
                    </dl>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                    {field('first', 'First name', { type: 'text', autoComplete: 'given-name' })}
                    {field('last', 'Last name', { type: 'text', autoComplete: 'family-name' })}
                    {field('email', 'Email', { type: 'email', autoComplete: 'email' })}
                    {field('comment', 'Your message', { as: 'textarea' })}
                    {/* Honeypot: off-screen, never shown to people. Bots that fill it are dropped. */}
                    <div className="hp-wrap" aria-hidden="true">
                        <label htmlFor="contact-website">Website</label>
                        <input
                            id="contact-website"
                            name="website"
                            type="text"
                            value={form.website}
                            onChange={update}
                            tabIndex={-1}
                            autoComplete="off"
                            aria-hidden="true"
                        />
                    </div>
                    <div className="turnstile-wrap">
                        <Turnstile
                            ref={turnstileRef}
                            siteKey={TURNSTILE_SITE_KEY}
                            options={{ size: 'flexible' }}
                            onSuccess={setToken}
                            onError={challengeFailed}
                            onExpire={() => setToken(null)}
                        />
                    </div>
                    <div className="form-actions">
                        <button type="submit" className="btn btn-green" disabled={status === 'sending' || !token}>
                            {status === 'sending' ? contact.sending : contact.btn}
                        </button>
                        <p className={`form-status is-${status}`} role="status" aria-live="polite">
                            {status === 'sent' && contact.sent}
                            {status === 'failed' && (errorMessage || contact.failed)}
                        </p>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default Contact;
